<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <!-- <dxi-item dataField="invoiceNumber" editorType="dxNumberBox" [label]="{ text: 'Invoice #' }"></dxi-item> -->
                    <dxi-item dataField="packingSlipNumber" editorType="dxNumberBox" [label]="{ text: 'Slip #' }"></dxi-item>
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item dataField="orderNumber" editorType="dxNumberBox" [label]="{ text: 'Order #' }"></dxi-item>
                    <!-- <dxi-item dataField="orderLineDetailId" [label]="{ text: 'Detail Id' }"></dxi-item> -->
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                    <dxi-item dataField="createdStart" editorType="dxDateBox" [label]="{ text: 'Created From' }"></dxi-item>
                    <dxi-item dataField="createdEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="partNumber" [label]="{ text: 'Part #' }"></dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item dataField="vin" [label]="{ text: 'VIN' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-1">
                <div *ngIf="packSlips" class="me-3">{{ packSlips.length }} {{ packSlips.length === 1 ? 'item found' : 'items found' }}</div>
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="packSlips">
        <dx-data-grid
            #dataGrid
            [dataSource]="packSlips"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
        >
            <dxi-column dataField="packingSlipNumber" caption="Slip #" width="80" cellTemplate="slipTemplate"></dxi-column>
            <dxi-column dataField="dealerCompany" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="deliveryMethod" width="125"></dxi-column>
            <dxi-column dataField="createDate" caption="Create Date" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="delivered" width="100"></dxi-column>
            <dxi-column dataField="ordersList" caption="Orders" width="180" cellTemplate="ordersTemplate"></dxi-column>
            <dxi-column dataField="invoiceList" caption="Invoices" width="180" cellTemplate="invoiceTemplate"></dxi-column>
            <dxi-column dataField="freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="freightInvoice" caption="Freight Invoice" alignment="left" width="100" cellTemplate="freightInvoiceTemplate"></dxi-column>
            <dxi-column dataField="" width="25"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="pack-slip-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'ordersTemplate'">
                <a *ngFor="let salesOrderNumber of cell.data.ordersList" [routerLink]="[]" (click)="openOrder(salesOrderNumber)">{{ salesOrderNumber || '' }} </a>
            </div>
            <div *dxTemplate="let cell of 'invoiceTemplate'">
                <a *ngFor="let invoiceNumber of cell.data.invoiceList" [routerLink]="[]" (click)="openInvoice(invoiceNumber)">{{ invoiceNumber || '' }} </a>
            </div>
            <div *dxTemplate="let cell of 'freightInvoiceTemplate'">
                <a [routerLink]="[]" (click)="openInvoice(cell.data.freightInvoice)">{{ cell.data.freightInvoice || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'slipTemplate'">
                <a [routerLink]="[]" (click)="openPackingSlip(cell.data.id)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button (click)="editPackSlip()" class="btn btn-secondary ms-2" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Edit Pack Slip</button>
                <button (click)="print(dataGrid.instance.getSelectedRowsData()[0])" class="btn btn-secondary ms-2" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Print</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="packSlips" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
